const state = {
    list: [
        {
            code: 'safaricom',
            class: 'link-safaricom',
            title: 'Safaricom',
            img: '/static/theme/africa/icons/safaricom-icon.svg',
            path: '#deposit-direct',
            enabled: false
        },
        {
            code: 'sport',
            class: 'link-sport',
            title: 'Sports',
            img: '/static/theme/africa/icons/xplay-sports-icon.svg',
            path: '/sport',
            enabled: false
        },
        {
            code: 'lottery',
            class: 'link-lottery',
            title: 'National Lottery',
            subtitle: 'tickets from Omoka',
            img: '/static/theme/africa/icons/xplay-lottery-icon.svg',
            img_africa: '/static/theme/africa/icons/lottery-icon-africa.svg',
            path: '/lobby/virtuals',
            enabled: false
        },
        {
            code: 'casino',
            class: 'link-casino',
            title: 'Casino',
            img: '/static/theme/africa/icons/xplay-casino-icon.svg',
            path: '/lobby/virtuals',
            enabled: false
        },
        {
            code: 'virtuales',
            class: 'link-virtuales',
            title: 'Try Virtuals',
            subtitle: 'from JantaBets',
            img: '/static/theme/africa/icons/xplay-virtuales-icon.svg',
            img_africa: '/static/theme/africa/icons/virtuales-icon-africa.svg',
            path: '/lobby/virtuals',
            enabled: false
        },
        {
            code: 'races',
            class: 'link-races',
            title: 'Try Races',
            subtitle: 'from JantaBets',
            img: '/static/theme/africa/icons/xplay-races-icon.svg',
            img_africa: '/static/theme/africa/icons/races-icon-africa.svg',
            path: '/lobby/races',
            enabled: false
        }        
    ]
};

export default {
    namespaced: true,
    state
};



// WEBPACK FOOTER //
// ./skins/xkiosk/data/welcome-links.js